<section class="sec">

    <!-- Grid row -->
    <div class="row">

        <!-- Grid column -->



        <div class="col-md-12 d-flex justify-content-center mb-5 menu">

            <!-- <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="all">All</button>
        <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="1">Tuja</button>
        <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="2">Brazi</button>
        <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="3">Ienupar</button>
        <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="4">Diverse</button>
        <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="5">Flori</button>
        <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="6">Amenajari</button> -->

            <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                <div class="btn-group mr-2" role="group" aria-label="First group">
                    <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="all">All</button>
                </div>

                <div class="btn-group mr-2" role="group" aria-label="Second group">
                    <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="1">Tuja</button>
                </div>

                <div class="btn-group mr-2" role="group" aria-label="Second group">
                    <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="2">Brazi</button>
                </div>

                <div class="btn-group mr-2" role="group" aria-label="Second group">
                    <button type="button" class="btn btn-outline-black waves-effect filter"
                        data-rel="3">Ienupar</button>
                </div>

                <div class="btn-group mr-2" role="group" aria-label="Second group">
                    <button type="button" class="btn btn-outline-black waves-effect filter"
                        data-rel="4">Diverse</button>
                </div>

                <div class="btn-group mr-2" role="group" aria-label="Second group">
                    <button type="button" class="btn btn-outline-black waves-effect filter" data-rel="5">Flori</button>
                </div>

                <div class="btn-group mr-2" role="group" aria-label="Second group">
                    <button type="button" class="btn btn-outline-black waves-effect filter"
                        data-rel="6">Amenajari</button>
                </div>


            </div>


        </div>

        <!-- Grid column -->

    </div>
    <!-- Grid row -->

    <!-- Grid row -->
    <div class="gallery" id="gallery">

        <!-- Grid column -->
        <div class="mb-3 pics animation all 1">
            <img class="img-fluid img" src="assets/pics/tuja/Grasilis.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 1">
            <img class="img-fluid" src="assets/pics/tuja/TuiaGlobosa.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 1">
            <img class="img-fluid" src="assets/pics/tuja/TuiaSmaragd.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 1">
            <img class="img-fluid" src="assets/pics/tuja/TuiaNanaAurea.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 2">
            <img class="img-fluid" src="assets/pics/brazi/Douglas.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 2">
            <img class="img-fluid" src="assets/pics/brazi/piceaglaucaconica.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 2">
            <img class="img-fluid" src="assets/pics/brazi/daisywhite.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 2">
            <img class="img-fluid" src="assets/pics/brazi/pinusmugo.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 2">
            <img class="img-fluid" src="assets/pics/brazi/pinnigra.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 2">
            <img class="img-fluid" src="assets/pics/brazi/piceapungens.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 2">
            <img class="img-fluid" src="assets/pics/brazi/abiesnordmanniana.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 3">
            <img class="img-fluid" src="assets/pics/ienupar/pingii-loderi.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 3">
            <img class="img-fluid" src="assets/pics/ienupar/spartan.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 3">
            <img class="img-fluid" src="assets/pics/ienupar/blue-arrow.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 3">
            <img class="img-fluid" src="assets/pics/ienupar/stricta.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 3">
            <img class="img-fluid" src="assets/pics/ienupar/variegata.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 3">
            <img class="img-fluid" src="assets/pics/ienupar/princeofwalles.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 3">
            <img class="img-fluid" src="assets/pics/ienupar/virginiana.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/artar.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/salcie.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/larice.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/chiparos.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/chiparosblue.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/hemerocallisyounique.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/carexbronze.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/tisataxusbacata.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/prunus.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/buxusbicolor.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/sempervirenspapa.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 4">
            <img class="img-fluid" src="assets/pics/plante_diverse/buxuscimisir.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 5">
            <img class="img-fluid" src="assets/pics/flori/trandafir.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 5">
            <img class="img-fluid" src="assets/pics/flori/royalstar.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="mb-3 pics animation all 5">
            <img class="img-fluid" src="assets/pics/flori/susan.jpg" alt="Card image cap">
        </div>
        <!-- Grid column -->



    </div>
</section>